import * as OTP from '@radix-ui/react-one-time-password-field';
import React from 'react';

import {twx} from '@/utils/tailwindUtils';

type OneTimePasswordFieldRootProps = Omit<React.ComponentPropsWithoutRef<typeof OTP.Root>, 'onSubmit'>;

export interface OneTimePasswordFieldProps extends OneTimePasswordFieldRootProps {
    className?: string;
    characterCount?: number;
    hasError?: boolean;
}

const OneTimePasswordField = React.forwardRef<HTMLDivElement, OneTimePasswordFieldProps>(
    ({className, characterCount = 6, hasError, ...restProps}, ref) => {
        const [value, setValue] = React.useState<string>('');

        const handleValueChange = (nextValue: string) => {
            setValue(nextValue);
        };

        return (
            <OTP.Root
                ref={ref}
                value={value}
                onValueChange={handleValueChange}
                className={twx('flex items-center justify-center gap-4', className)}
                data-error={hasError ? 'true' : undefined}
                autoComplete='one-time-code'
                {...restProps}
            >
                {Array.from({length: characterCount}).map((_, index) => {
                    const isFilled = Boolean(value?.[index]);

                    return (
                        <OTP.Input
                            key={index}
                            className={twx(
                                'h-12 min-w-6 basis-12 text-center text-16 font-normal leading-16',
                                'border-b bg-transparent text-primary outline-none',
                                'focus:border-primary focus-visible:border-primary',
                                isFilled ? 'border-primary' : 'border-primary-dark-25',
                                hasError && 'border-b-2 border-error'
                            )}
                            inputMode='numeric'
                        />
                    );
                })}
                <OTP.HiddenInput />
            </OTP.Root>
        );
    }
);

OneTimePasswordField.displayName = 'OneTimePasswordField';

export default OneTimePasswordField;
